export const kolData = [
    {
        "id": 1,
        "image": require("../images/kol/kol_01.webp"),
        "imageSmall": require("../images/kol/kol_01_330w.webp"),
        "name": "小日刀口",
        "lazyArticle": {
            "title": "小日刀口潮Way台南旅遊攻略",
            "link": "https://akizhao.pixnet.net/blog/post/121714601"
        },
        "recommendArticle": {
            "title": "小日刀口台南私藏秘境",
            "link": "https://akizhao.pixnet.net/blog/post/121730174"
        }
    },
    {
        "id": 2,
        "image": require("../images/kol/kol_02.webp"),
        "imageSmall": require("../images/kol/kol_02_330w.webp"),
        "name": "Mita's遊樂園",
        "lazyArticle": {
            "title": "Mita潮Way台南旅遊攻略",
            "link": "https://mita1229.pixnet.net/blog/post/232677619"
        },
        "recommendArticle": {
            "title": "Mita台南私藏店家",
            "link": "https://mita1229.pixnet.net/blog/post/232690096"
        }
    },
    {
        "id": 3,
        "image": require("../images/kol/kol_03.webp"),
        "imageSmall": require("../images/kol/kol_03_330w.webp"),
        "name": "雖然只有156",
        "lazyArticle": {
            "title": "156潮Way台南旅遊攻略",
            "link": "https://ir47363.pixnet.net/blog/post/364138200"
        },
        "recommendArticle": {
            "title": "雖然只有156台南私藏店家",
            "link": "https://ir47363.pixnet.net/blog/post/364138206"
        }
    },
    {
        "id": 4,
        "image": require("../images/kol/kol_04.webp"),
        "imageSmall": require("../images/kol/kol_04_330w.webp"),
        "name": "Riin’s life",
        "lazyArticle": {
            "title": "Riin潮Way台南旅遊攻略",
            "link": "https://riintravel.tw/blog/post/339738579"
        },
        "recommendArticle": {
            "title": "Riin台南私藏店家",
            "link": "https://riintravel.tw/blog/post/339738771"
        }
    },
    {
        "id": 5,
        "image": require("../images/kol/kol_05.webp"),
        "imageSmall": require("../images/kol/kol_05_330w.webp"),
        "name": "鏞鏞甫甫",
        "lazyArticle": {
            "title": "鏞甫媽咪潮Way台南旅遊攻略",
            "link": "https://weantiffany.pixnet.net/blog/post/70355226"
        },
        "recommendArticle": {
            "title": "鏞甫媽咪台南私藏景點",
            "link": "https://weantiffany.pixnet.net/blog/post/70355604"
        }
    },
    {
        "id": 6,
        "image": require("../images/kol/kol_06.webp"),
        "imageSmall": require("../images/kol/kol_06_330w.webp"),
        "name": "希遊記",
        "lazyArticle": {
            "title": "希遊記潮Way台南旅遊攻略",
            "link": "https://silviathetraveler.com/tainan-travel/"
        },
        "recommendArticle": {
            "title": "希遊記台南私藏店家",
            "link": "https://silviathetraveler.com/stay-coffee-tainan/"
        }
    },
    {
        "id": 7,
        "image": require("../images/kol/kol_07.webp"),
        "imageSmall": require("../images/kol/kol_07_330w.webp"),
        "name": "瑞瑞的日常",
        "lazyArticle": {
            "title": "瑞瑞潮Way台南旅遊攻略",
            "link": "https://livi1233.pixnet.net/blog/post/337742845"
        },
        "recommendArticle": {
            "title": "瑞瑞台南私藏景點",
            "link": "https://livi1233.pixnet.net/blog/post/337743041"
        }
    },
    {
        "id": 8,
        "image": require("../images/kol/kol_08.webp"),
        "imageSmall": require("../images/kol/kol_08_330w.webp"),
        "name": "八字眉芯芯",
        "lazyArticle": {
            "title": "芯芯潮Way台南旅遊攻略",
            "link": "https://ma16zaq2000.pixnet.net/blog/post/355664545"
        },
        "recommendArticle": {
            "title": "芯芯台南私藏店家",
            "link": "https://ma16zaq2000.pixnet.net/blog/post/355655587"
        }
    },
    {
        "id": 9,
        "image": require("../images/kol/kol_09.webp"),
        "imageSmall": require("../images/kol/kol_09_330w.webp"),
        "name": "肉魯",
        "lazyArticle": {
            "title": "肉魯潮Way台南旅遊攻略",
            "link": "https://damon624.pixnet.net/blog/post/48569092"
        },
        "recommendArticle": {
            "title": "肉魯台南私藏景點",
            "link": "https://damon624.pixnet.net/blog/post/48569360"
        }
    },
    {
        "id": 10,
        "image": require("../images/kol/kol_10.webp"),
        "imageSmall": require("../images/kol/kol_10_330w.webp"),
        "name": "柯蘿依",
        "lazyArticle": {
            "title": "柯蘿依潮Way台南旅遊攻略",
            "link": "https://www.chloestyle.tw/blog/post/226368934"
        },
        "recommendArticle": {
            "title": "柯蘿依台南私藏店家",
            "link": "https://www.chloestyle.tw/blog/post/226354141"
        }
    },
    {
        "id": 11,
        "image": require("../images/kol/kol_11.webp"),
        "imageSmall": require("../images/kol/kol_11_330w.webp"),
        "name": "藥師吉米",
        "lazyArticle": {
            "title": "藥師吉米潮Way台南旅遊攻略",
            "link": "https://drugs.pixnet.net/blog/post/50291460"
        },
        "recommendArticle": {
            "title": "藥師吉米台南私藏景點",
            "link": "https://drugs.pixnet.net/blog/post/50291340"
        }
    }
];
